import { render, staticRenderFns } from "./activitySetup.html?vue&type=template&id=54a91d3e&scoped=true&"
import script from "./activitySetup.vue?vue&type=script&lang=js&"
export * from "./activitySetup.vue?vue&type=script&lang=js&"
import style0 from "./activitySetup.css?vue&type=style&index=0&id=54a91d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a91d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer,VLayout})
